import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { blue, navy, glass, glowFocus, transition } from './colorUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Select', 'blueTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      [`${componentCls}-selector`]: {
        borderRadius: '4px !important',
        background: `${glass.input} !important`,
        borderColor: `${navy[700]} !important`,
        transition,
      },

      '&:hover': {
        [`${componentCls}-selector`]: {
          borderColor: `${blue[500]}60 !important`,
        },
      },

      [`&${componentCls}-focused`]: {
        [`${componentCls}-selector`]: {
          borderColor: `${blue[500]} !important`,
          boxShadow: `${glowFocus} !important`,
        },
      },

      [`${componentCls}-arrow`]: {
        color: `#94a3b8 !important`,
      },

      [`${componentCls}-clear`]: {
        background: `${navy[800]} !important`,
        color: `#94a3b8 !important`,
        '&:hover': {
          color: `${blue[400]} !important`,
        },
      },
    },
  }
})
